import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { requiredRule, urlRule } from '@utils/rules'
import { Alert, Flex, Form, Input, Space, Switch, Typography } from 'antd'

const { Text } = Typography

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Space orientation="vertical">
      <Alert
        type="info"
        title={
          <Flex vertical>
            <Text>
              Prior creating your audience here you have to ask Sevenrooms to
              create it for you.
            </Text>
            <Text>
              There are two types of audiences: venue group level (global) &
              venue level.
            </Text>
            <Text>
              Once created Sevenrooms send you a document including all
              attributes needed below.
            </Text>
          </Flex>
        }
      />
      <Form {...formProps} form={form} layout="vertical">
        <Form.Item
          label={'Name'}
          name={'name'}
          help={
            'Input a simple name the describe best your audience. For example: Global app, Global chatbot, Venue Z app, ... Warning: the name has to be unique'
          }
          rules={[requiredRule()]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={'Endpoint'}
          name={'endpoint'}
          rules={[requiredRule(), urlRule()]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={'Client ID'}
          name={'clientId'}
          rules={[requiredRule()]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'clientSecret'}
          label={'Client Secret'}
          rules={[requiredRule()]}
        >
          <Input />
        </Form.Item>
        <Form.Item label={'Webhook Key'} name={'webhookKey'} rules={[]}>
          <Input />
        </Form.Item>
        <Form.Item
          name={'venueGroupId'}
          label={'Venue Group ID'}
          rules={[requiredRule()]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          rules={[]}
          name={'isGlobal'}
          valuePropName="checked"
          label={'Is venue group level audience'}
          help={
            'Check this only if your audience is at the venue group level. In case of venue-level audience do not check.'
          }
        >
          <Switch />
        </Form.Item>
      </Form>
    </Space>
  )
}

export default Create
